module.exports = __webpack_public_path__ + "static/media/15f-01-HOME_Vista-de-exhibicion_Inscripción-en-la-Tierra.d01b93a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15f/15f-01-HOME_Vista-de-exhibicion_Inscripción-en-la-Tierra.jpg
// module id = 174
// module chunks = 0